// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1412": "03a31bbf2b6b","6406": "4b8a26721fc2","7424": "bfd23840dd44",}[chunkId] + ".css"
}